var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    y: 5.66669,
    width: 4.88889,
    height: 3.66667,
    rx: 1.83333,
    fill: "#022CE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    y: 13,
    width: 4.88889,
    height: 3.66667,
    rx: 1.83333,
    fill: "#022CE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    y: 20.3333,
    width: 4.88889,
    height: 3.66667,
    rx: 1.83333,
    fill: "#022CE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30495 1.56145L20.5352 1.5556C24.6014 1.5556 27.1179 4.2182 27.1179 8.2844V21.7157C27.1179 25.7614 24.6204 28.4153 20.5892 28.4401L9.35899 28.4445C5.66661 28.4445 2.77771 26.009 2.77771 21.7157V8.2844C2.77771 4.33338 4.67047 1.58999 9.30495 1.56145ZM19.4874 21.7778H10.1918C9.90174 21.7778 9.66662 21.5427 9.66662 21.2527C9.66662 18.6175 11.8105 16.4736 14.4457 16.4736H15.2335C17.8686 16.4736 20.0125 18.6175 20.0125 21.2527C20.0125 21.5427 19.7774 21.7778 19.4874 21.7778ZM11.2421 11.8783C11.2421 13.8329 12.8324 15.4232 14.7871 15.4232C16.7417 15.4232 18.332 13.8329 18.332 11.8783C18.332 9.92361 16.7417 8.33335 14.7871 8.33335C12.8324 8.33335 11.2421 9.92361 11.2421 11.8783Z",
    fill: "#022CE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.2008c8e0.svg";
export { ForwardRef as ReactComponent };